import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=72698678&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=ts"
export * from "./ConfirmOrder.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmOrder.vue?vue&type=style&index=0&id=72698678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72698678",
  null
  
)

export default component.exports